import React from 'react';
import { useState } from 'react';
import { Stack, IconButton, FontIcon, Icon, FontSizes } from 'office-ui-fabric-react';
import { MyContext } from '../../../context';

/*

interface ContentUnderstandingResultProps {
	loading: boolean,
	cuData: string,
}


interface AggregatedCuResult {
	type : "aggregatedCuResult",
	version : 1,
	fields : Record<string,CuAggregation>
}

interface CuAggregation {
		audio : CuField |null,
		chat : CuField |null,
		mail : CuField |null,
		merged : CuField |null
	}

type CuField = CuSimpleField | CuListField | CuTableField | CuObjectField;

interface CuSimpleField{
	"type" : "simple",
	value : string
}

interface CuListField{
	"type" : "list",
	value : string[]
}

interface CuTableField{
	"type" : "table",
	value : Record<string,string>[]
}

interface CuObjectField{
	"type" : "object",
	value : Record<string,string>
}

type Channels = keyof CuAggregation; // Honestly, I have no idea why keyof does not work here ... But it does not. (maybe because project is not correctly set up for ts)
*/
const filterChoices/*:(Channels|undefined)[]*/ = [undefined,'audio','chat','mail','merged']
const unmergedChannels/*:(Exclude<Channels,'merged'>)[]*/ = ['audio','chat','mail']

export default function ContentUnderstandingResult({ loading, cuData }/*:ContentUnderstandingResultProps*/) {

	const [expanded, setExpanded] = useState(false);
	const [filter, setFilter] = useState/*<Channels|undefined>*/(undefined);

	if (!cuData || loading) {
		return null;
	}

	try {
		const fields/* :AggregatedCuResult */ = JSON.parse(cuData);
		

		return (
			<div className='flex-container--content-understanding'>
				<Stack>
					<Stack.Item style={{ marginTop: "5px", marginRight: "5px" }}>
						{renderExpander(expanded, setExpanded)}
					</Stack.Item>
					{expanded &&
						<Stack.Item style={{ marginTop: "5px", marginRight: "5px" }}>
							<div className='cu-filter-panel'>
								<span>{translate('compliance','cuQuestionResultFilter')}</span>
								{filterChoices.map(e => makeTypeFilterButton(e,filter,setFilter))}
							</div>
							<div style={{ display: "grid", gridTemplateColumns: "max-content min-content auto", columnGap: "20px", rowGap:"20px" }}>
								<span style={{ fontWeight : "bold"}}>{translate("compliance","contentUnderstandingTableHeadlineKey")}</span>
								<span style={{ fontWeight : "bold"}}></span>
								<span style={{ fontWeight : "bold"}}>{translate("compliance","contentUnderstandingTableHeadlineValue")}</span>
								{renderContent(fields,filter)}
							</div>
						</Stack.Item>
					}
				</Stack>
			</div>
		)
	} catch (e){
		console.error("Content Understanding is not valid json!",e)
		return null;
	}
}

function makeTypeFilterButton(e /*:Channels|undefined*/, filter/*: Channels|undefined*/, setFilter/*: React.Dispatch<React.SetStateAction<Channels | undefined>>*/)/*: JSX.Element*/ {
	const icon/*:[string,string]*/ = e ? getIconForChannel(e) : ["StatusCircleBlock","None"];
	return <Icon key={"filterIcon_"+e} className={"ContentColor cu-filter-button " + (e === filter ? "cu-filter-button-active" : "cu-filter-button-inactive")} 
	style={{fontSize: FontSizes.icon }} iconName={icon[0]} title={icon[1]}
	onClick={() => setFilter(e)}/>
}

function renderContent(content/*:AggregatedCuResult*/, filter/*: Channels|undefined*/)/*:JSX.Element[]*/{
	const res/*:JSX.Element[]*/ = []
	
	Object.entries(content.fields).forEach((e,index) => {
		const entry = renderField(e[0],e[1],res.length !== 0,filter);
		entry.forEach(e => res.push(e))
	})
	return res;
}

function makeSpacer(fieldId/*:string*/){
	return Array(3).fill(0).map((_,i) => <span key={fieldId+"_spacer_"+i} className="cu-spacer"></span>)
}

function renderField(fieldKey/*:string*/, value/*:CuField*/, spacer/* :boolean */=false, filter/*: Channels|undefined */ = undefined)/* :JSX.Element[] */{
	const res/* :JSX.Element[] */ = []
	if(spacer){
		const spacers = makeSpacer(fieldKey);
		spacers.forEach(e => res.push(e))
	}

	if(value.merged && (filter === 'merged' || filter === undefined)){
		res.push(<span key={fieldKey+"_key"}>{fieldKey}</span>)
		res.push(makeTypeColIconEntry(fieldKey,"merged"))
		res.push(renderValue(fieldKey+"_value_",value.merged))
	}else if(!value.merged){
		if(filter === undefined){
			res.push(<span key={fieldKey+"_key"}>{fieldKey}</span>);
			for(const key of unmergedChannels){
				if(value[key]){
					if(res.length > (spacer ? 4 : 1)){
						res.push(<span key={fieldKey+"_"+key+"_key"} />)
					}
					res.push(makeTypeColIconEntry(fieldKey,key))
					res.push(renderValue(fieldKey+"_"+key+"_value_",value[key]))
				}
			}
		}else if(value[filter]){
			res.push(<span key={fieldKey+"_key"}>{fieldKey}</span>)
			res.push(makeTypeColIconEntry(fieldKey,filter))
			res.push(renderValue(fieldKey+"_value_",value[filter]))
		}
	}
	return res;
}
function getIconForChannel(channel/* :Channels */)/* :[string,string] */ {
	switch(channel){
		case "audio": return ["Microphone","Audio"]
		case 'chat' : return ["Chat","Chat"]
		case 'mail' : return ["Mail","Mail"]
		case 'merged' : return ["BranchMerge","Merged"]
	}
}

function makeTypeColIconEntry(fieldKey/* :string */, type/* : Channels */)/* : JSX.Element */{
	const icon/* :[string,string] */ = getIconForChannel(type);
	return <Icon key={fieldKey+"_"+type+"_source"} className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName={icon[0]} title={icon[1]} />
}

function renderValue(key/* :string */,value/* :CuField */)/* :JSX.Element */{
	if(value.type === 'simple'){
		return <span key={key+"_val"} >{value.value}</span>
	}else if(value.type === 'list'){
		return <ul>
			{value.value.map((e,i) => <li key={key+"_val_"+i}>{e}</li>)}
		</ul>
	}else if(value.type === 'object'){
		return makeTable(key,[value.value])
	}else if(value.type === 'table'){
		return makeTable(key,value.value)
	}else{
		return <span>Unknown Construct!</span>
	}
}

function makeTable(fieldKey/* :string */, columns/* : Record<string,string>[] */)/* :JSX.Element */{
	const keys/* :Set<string> */ = new Set();
	columns.flatMap(Object.keys).forEach(e => keys.add(e));
	const keysArr = Array.from(keys).filter(e => e !== undefined && e !== null);

	const colTemplate = "repeat("+keysArr.length+", max-content)"
	return <div key={fieldKey+"_tabel"} className="cu-value cu-table" style={{ gridTemplateColumns : colTemplate}}>
		{keysArr.map((e,i) =>
		<span className={"cu-value cu-table-cell cu-table-header " + (i > 0 ?"":"cu-table-cell-first")} key={fieldKey+"_"+e}>
			 {e}
		</span>
		)}
		{columns.flatMap( (row,rowIndex) => {
			if(row){
				return keysArr.map( (e, colIndex) =>{
					let celClass = "cu-value cu-table-cell cu-table-value";
					if(colIndex === 0){
						celClass += " cu-table-cell-first"
					}
					if( rowIndex === keysArr.length){
						celClass += " cu-table-cell-lastRow"
					}

					return <span className={celClass} key={fieldKey+"_table_value"+e+"_"+rowIndex}>
						{row[e]}
					</span>
				}
				)
			}
		})}
	</div>
}


function translate(prefix/* :string */, rs/* :string */){
	return <MyContext.Consumer>{(context) => (<> {context.getTranslation(prefix, rs)}</>)}</MyContext.Consumer>
}

function renderExpander(expanded/* :boolean */, setExpanded/* :(e:boolean)=>void */) {
	return (

		<Stack horizontal>
			<IconButton
				iconProps={{ iconName: expanded ? 'ChevronDown' : 'ChevronRight' }}
				onClick={e => setExpanded(!expanded)}
			/>
			<FontIcon
				iconName={"ReceiptTentative"}
				style={{ marginRight: "5px", fontSize: "20px", alignSelf: "center" }} // Groesres Icon
			/>
			<h4>{translate("compliance" , "contentUnderstandingCardTitle")}</h4>
		</Stack>

	)
}
